module.exports = __webpack_public_path__ + "static/Mind-Mate-0ad867861a0f1ab28001e1dba73e364a.mp4";